<template>
	<div v-loading="loading" class="base_scroll_page">
		<div class="b_scroller">
			<!-- 查询条件 -->
			<div class="base_inquire">
				<div v-if="authInfo.ucategory == 1 || authInfo.ucategory == 2" class="b_item">
					<span class="b_label">代理/机构名称：</span>
					<el-input v-model="search_agent" class="b_inp" placeholder="名称"></el-input>
				</div>

				<div class="b_item">
					<span class="b_label">开始时间：</span>
					<el-date-picker v-model="search_startDate" :editable="false" placeholder="开始时间" type="date"
						value-format="yyyy-MM-dd" @change="handleSearchStartDateClick">
					</el-date-picker>
				</div>

				<div class="b_item">
					<span class="b_label">结束时间：</span>
					<el-date-picker v-model="search_endDate" :editable="false" placeholder="结束时间" type="date"
						value-format="yyyy-MM-dd" @change="handleSearchEndDateClick">
					</el-date-picker>
				</div>

				<div class="b_item">
					<span class="b_label">卡片天数：</span>
					<el-select v-model="search_day" class="b_inp" :clearable="false">
						<el-option :value="null" label="全部"></el-option>
						<el-option :value="15" label="15天"></el-option>
						<el-option :value="30" label="30天"></el-option>
						<el-option :value="90" label="90天"></el-option>
						<el-option :value="180" label="180天"></el-option>
						<el-option :value="365" label="365天"></el-option>
					</el-select>
				</div>

				<div class="b_item">
					<span class="b_label">卡号：</span>
					<el-input v-model="search_number" class="b_inp" placeholder="卡号"></el-input>
				</div>


				<div class="b_item">
					<span class="b_label">患者账号：</span>
					<el-input v-model="search_code" class="b_inp" placeholder="患者账号"></el-input>
				</div>

				<div class="b_item">
					<span class="b_label">激活状态：</span>
					<el-select v-model="search_activeState" class="b_inp" :clearable="false">
						<el-option :value="null" label="全部"></el-option>
						<el-option :value="1" label="已激活"></el-option>
						<el-option :value="0" label="未激活"></el-option>
					</el-select>
				</div>

				<div class="b_item">
					<span class="b_label">卡片状态：</span>
					<el-select v-model="search_cardState" class="b_inp" placeholder="请选择" :clearable="false">
						<el-option :value="null" label="全部"></el-option>
						<el-option v-for="v in cardState" :key="v.id" :value="v.id" :label="v.name"></el-option>
					</el-select>
				</div>

				<div class="b_item">
					<span class="b_label">卡片选择：</span>
					<el-select v-model="search_cardName" class="b_inp" placeholder="请选择" :clearable="false">
						<el-option :value="null" label="全部"></el-option>
						<el-option v-for="v in allCard" :key="v.id" :value="v.name" :label="v.name"></el-option>
					</el-select>
				</div>

				<el-button type="primary" @click="handleSearchClick">查询</el-button>
			</div>
			<!-- 查询条件 end -->

			<!-- action -->
			<div style="margin-top: 20px;text-align: right;">
				<el-button type="primary" @click="exportExcel">导出</el-button>
				<el-button v-if="authInfo.ucategory == 1||authInfo.ucategory == 2" type="primary"
					@click="setAgent">设置代理</el-button>
				<el-button v-if="authInfo.ucategory == 1||authInfo.ucategory == 2" type="primary"
					@click="setInstitution">设置机构</el-button>
				<el-button v-if="authInfo.ucategory == 1" type="primary" @click="setCardState">设置卡片状态</el-button>
			</div>
			<!-- action end -->

			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
					<el-table-column type="selection">
					</el-table-column>
					<el-table-column prop="name" label="卡片名称">
					</el-table-column>
					<el-table-column prop="day" label="卡片天数">
					</el-table-column>
					<el-table-column prop="number" label="卡号">
					</el-table-column>
					<el-table-column v-if="authInfo.ucategory == 1" prop="activeCode" label="激活码">
					</el-table-column>
					<el-table-column prop="agentName" label="代理/机构名称">
					</el-table-column>
					<el-table-column prop="activeStateLabel" label="激活状态">
					</el-table-column>
					<el-table-column prop="userName" label="患者姓名">
					</el-table-column>
					<el-table-column prop="userCode" label="患者账号">
					</el-table-column>
					<el-table-column v-if="authInfo.ucategory == 1" prop="stateLabel" label="卡片状态">
					</el-table-column>
					<el-table-column prop="optName" label="激活人员">
					</el-table-column>
					<el-table-column v-if="authInfo.ucategory == 1" prop="operator" label="卡片操作人">
					</el-table-column>
					<el-table-column prop="updateTs" label="激活时间">
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->

			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination layout="total, sizes, prev, pager, next, jumper"
						:page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]" next-text="下一页" :total="total"
						:current-page="currentPage" @size-change="handleSizeChange" @current-change="handlePageChange">
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>

		<agent-site v-model="agentSite_display" :ids="selectedIds" @onSuccess="setAgentSuccess"></agent-site>

		<state-site v-model="stateSite_display" :ids="selectedIds" @onSuccess="setCardStateSuccess"></state-site>

		<Institution-Site v-model="setInstitution_display" :ids="selectedIds"
			@onSuccess="setInstitutionSuccess"></Institution-Site>
	</div>
</template>

<script>
	import BaseMethods from '../../../../../assets/js/base.js';
	import Api from '../../../../../api/index.js';
	import AgentSite from './components/agent_site.vue';
	import StateSite from './components/state_site.vue';
	import InstitutionSite from './components/institution_site';
	import {
		mapState,
		mapMutations
	} from 'vuex';

	export default {
		mounted() {

			this.search();
			this.findAllAgent();
		},
		data() {
			return {
				loading: false,
				pageSize: 10,
				search_agent: '',
				search_startDate: '',
				search_endDate: '',
				search_day: null,
				search_number: '',
				search_code: '',
				search_activeState: null,
				search_cardState: null,
				search_cardName: null,

				tableData: [],
				total: 0,
				currentPage: 1,

				selectedIds: [],

				agentSite_display: false,

				stateSite_display: false,
				setInstitution_display: false,
			}
		},
		computed: {
			...mapState([
				'allCard',
				'cardState',
				'authInfo'
			])
		},
		methods: {
			/************************ @Events *******************************/
			// 切换查询时间
			handleSearchStartDateClick() {
				this.compareSearchDate();
			},
			// 切换查询时间
			handleSearchEndDateClick() {
				this.compareSearchDate();
			},
			// 点击查询
			handleSearchClick() {
				this.currentPage = 1;
				this.search();

			},
			// 切换页码
			handlePageChange(page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.search();
				}
			},
			// 表格选择
			handleSelectionChange(val) {
				let list = [];
				for (var i = 0; i < val.length; i++) {
					list.push(val[i].id);
				}
				this.selectedIds = list;
			},
			// 设置代理商
			setAgent() {
				if (this.selectedIds.length) {
					this.agentSite_display = true;
				} else {
					this.$message.warning('请选择卡片');
				}
			},
			//设置机构
			setInstitution() {
				if (this.selectedIds.length) {
					this.setInstitution_display = true;
				} else {
					this.$message.warning('请选择卡片');
				}
			},

			// 代理商设置成功
			setAgentSuccess() {
				this.search();
			},
			//设置机构
			setInstitutionSuccess() {
				this.search();
			},
			// 设置卡片状态
			setCardState() {
				if (this.selectedIds.length) {
					this.stateSite_display = true;
				} else {
					this.$message.warning('请选择卡片');
				}
			},
			// 卡片状态设置成功
			setCardStateSuccess() {
				this.search();
			},


			// 导出Excel数据
			exportExcel() {
				const that = this;
				that.loading = true;
				var _requestData = {
					pageNum: that.currentPage,
					pageSize: 10,
					enterpriseName: that.search_agent,
					start: that.search_startDate,
					end: that.search_endDate,
					times: that.search_day,
					cardNo: that.search_number,
					curCode: that.search_code, //患者账号
					cardStatus: that.search_activeState,
					cardSmallType: that.search_cardState,
					cardName: that.search_cardName,
					excel: 1,
				};
				Api.findCardByPageAndCondition(_requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						var str = '序号,卡片名称,卡片天数,卡号,机构名称,激活状态,患者姓名,患者账号,卡片状态,激活人员,激活时间,\n';
						for (var i = 0; i < res.data.data.length; i++) {
							str += `${ i+1 },`
							str += res.data.data[i].cardName || '';
							str += ',';
							str += res.data.data[i].times + '天' || '';
							str += ',';
							str += res.data.data[i].cardNo || '';
							str += ',';
							str += res.data.data[i].enterpriseName || '';
							str += ',';
							str += that.mapActiveStateToLabel(res.data.data[i].cardStatus);
							str += ',';
							str += res.data.data[i].userName || '';
							str += ',';
							str += res.data.data[i].ucode || '';
							str += ',';
							str += that.mapCardStateToLabel(res.data.data[i].cardSmallType);
							str += ',';
							str += res.data.data[i].optName || '';
							str += ',';
							str += res.data.data[i].updateTs || '';
							str += ',';
							str += '\t,';
							str += '\n';
						}
						BaseMethods.outputExcel(str, '卡片管理');
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},





			/************************ @Function *******************************/

			handleSizeChange(val) {
				let that = this
				that.pageSize = val
				that.search();
			},
			// 查询
			search() {
				const that = this;
				that.loading = true;
				let requestData = {
					pageNum: that.currentPage,
					pageSize: that.pageSize,
					enterpriseName: that.search_agent,
					start: that.search_startDate,
					end: that.search_endDate,
					times: that.search_day,
					cardNo: that.search_number,
					curCode: that.search_code, //患者账号
					cardStatus: that.search_activeState,
					cardSmallType: that.search_cardState,
					cardName: that.search_cardName
				};
				Api.findCardByPageAndCondition(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						let list = [];
						res.data.data.records.forEach(v => {
							list.push({
								id: v.cardId,
								name: v.cardName || '',
								day: v.times + '天',
								number: v.cardNo || '',
								activeCode: v.codePassword || '',
								agentName: v.enterpriseName || '',
								activeState: v.cardStatus || '',
								activeStateLabel: that.mapActiveStateToLabel(v.cardStatus),
								userName: v.userName || '',
								userCode: v.ucode || '',
								state: v.cardSmallType || '',
								stateLabel: that.mapCardStateToLabel(v.cardSmallType),
								operator: v.adminName || '',
								optName: v.optName || '',
								updateTs: v.updateTs || '',
							});
						});
						that.total = res.data.data.total;
						that.tableData = list;
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},


			// 获取代理商
			findAllAgent() {
				const that = this;
				// 0超级管理员 1是代理  2是机构
				let requestData = {
					category: 2
				}
				Api.findAllAgent(requestData).then((res) => {
					if (res.data.success) {
						let list = [];
						res.data.data.forEach((v) => {
							list.push({
								id: v.enterpriseId,
								name: v.enterpriseName
							});
						});
						that.setAllAgent(list);
						// Loading.close();
						// that.$router.replace({
						// 	path: '/index'
						// });
					} else {
						// Loading.close();
						that.$message.error(res.data.message);
					}
				}, (e) => {
					// Loading.close();
					that.$message.error(e.message);
				});
			},

			// 把激活状态转为文字
			mapActiveStateToLabel(state) {
				let r = '';
				switch (state) {
					case 0:
						r = '未激活';
						break;
					case 1:
						r = '已激活';
						break;
				}
				return r;
			},
			// 把卡片状态转为文字
			mapCardStateToLabel(state) {
				let r = '';
				switch (state) {
					case 0:
						r = '售出';
						break;
					case 1:
						r = '赠送';
						break;
					case 2:
						r = '体验';
						break;
					case 3:
						r = '测试';
						break;
					case 4:
						r = '未出账';
						break;
				}
				return r;
			},
			// 比较开始时间和结束时间
			compareSearchDate() {
				if (this.search_startDate && this.search_endDate) {
					var startDate = new Date(this.search_startDate).getTime(),
						endDate = new Date(this.search_endDate).getTime();
					if (endDate < startDate) {
						this.search_endDate = '';
						this.$message.warning('结束时间不能小于开始时间');
					}
				}
			},
			...mapMutations({
				'setAllAgent': 'setAllAgent'
			})
		},
		components: {
			AgentSite,
			StateSite,
			InstitutionSite
		},

	}
</script>

<style scoped>
</style>